module.exports = __webpack_public_path__ + "img/logo.bb0576f5.jpeg";